import { atom } from "recoil";
import { ProgramSetupDataState, programSetupApi } from "../api/programSetupApi";

/*
  Atom Effects:
  - setSelf: atom 초깃값을 세팅
  - onSet: atom 값이 바뀔 때 호출
*/
const apiEffect = ({ setSelf, onSet }: any) => {
  // ① 서버에서 전체 페이지 데이터 로드하여 atom 초기값 세팅
  programSetupApi
    .loadAllPageData()
    .then((response) => {
      if (response.result?.data) {
        setSelf(response.result.data);
      }
    })
    .catch((error) => {
      console.warn("Error loading program setup data from API:", error);
    });

  // ② atom 값이 바뀔 때마다 변경된 페이지 데이터를 서버에 저장
  onSet(
    (
      newValue: ProgramSetupDataState,
      oldValue: ProgramSetupDataState,
      isReset: boolean
    ) => {
      if (isReset) return;

      // 변경된 pageKey들을 찾아서 각각 저장
      Object.keys(newValue).forEach((pageKey) => {
        const newPageData = newValue[pageKey];
        const oldPageData = oldValue[pageKey];

        // 해당 페이지 데이터가 변경되었을 때만 저장
        if (JSON.stringify(newPageData) !== JSON.stringify(oldPageData)) {
          programSetupApi.savePageData(pageKey, newPageData).catch((error) => {
            console.error(`Error saving page data for ${pageKey}:`, error);
          });
        }
      });
    }
  );
};

export const programSetupDataState = atom<ProgramSetupDataState>({
  key: "programSetupDataState",
  default: {},
  effects: [
    apiEffect,
    // ↑ 서버에서 전체 데이터 로드하여 초기화
  ],
});